<template>
    <i
        :class="[iconStyleAbbreviation, 'fa-' + icon, this.textSizeClass]"
        class="fa-fw self-center"
    ></i>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    icon: {
      type: String,
      required: true
    },

    size: {
      type: String,
      default: 'md',
      validator (value) {
        return [
          'sm', 'md', 'lg'
        ].includes(value)
      }
    }
  },

  data () {
    return {
      iconStyleAbbreviation: window.iconStyleAbbreviation
    }
  },

  computed: {
    textSizeClass () {
      switch (this.size) {
        case 'lg':
          return 'text-4xl'
        case 'md':
          return 'md:text-2xl'
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>
